module.exports = __webpack_public_path__ + "img/Phillip Rigsby.fa9a990e.jpg";